function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m322.967 182.394c-5.857-5.857-15.355-5.857-21.213 0-5.857 5.857-5.857 15.355 0 21.213l21.213 21.213c2.929 2.929 6.768 4.394 10.606 4.394s7.678-1.465 10.606-4.394l42.426-42.426c5.858-5.857 5.858-15.355 0-21.213-5.857-5.859-15.354-5.857-21.213 0l-31.818 31.819z",
    id: "id_101",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m365.394 237.181-31.82 31.819-10.607-10.606c-5.857-5.857-15.355-5.857-21.213 0-5.857 5.857-5.857 15.355 0 21.213l21.213 21.213c2.929 2.929 6.768 4.394 10.606 4.394s7.678-1.465 10.606-4.394l42.426-42.426c5.858-5.857 5.858-15.355 0-21.213-5.856-5.86-15.353-5.858-21.211 0z",
    id: "id_102",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 178h-120c-8.284 0-15 6.716-15 15s6.716 15 15 15h120c8.284 0 15-6.716 15-15s-6.716-15-15-15z",
    id: "id_103",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 254h-120c-8.284 0-15 6.716-15 15s6.716 15 15 15h120c8.284 0 15-6.716 15-15s-6.716-15-15-15z",
    id: "id_104",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 330h-120c-8.284 0-15 6.716-15 15s6.716 15 15 15h120c8.284 0 15-6.716 15-15s-6.716-15-15-15z",
    id: "id_105",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 406h-120c-8.284 0-15 6.716-15 15s6.716 15 15 15h120c8.284 0 15-6.716 15-15s-6.716-15-15-15z",
    id: "id_106",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m436 60h-85.305c-5.653-11.992-17.776-20-31.637-20h-13.846l5.341-21.362c1.12-4.48.113-9.229-2.729-12.869-2.844-3.641-7.205-5.769-11.824-5.769h-80c-4.619 0-8.98 2.128-11.823 5.769-2.842 3.641-3.849 8.389-2.729 12.869l5.341 21.362h-13.846c-13.86 0-25.984 8.008-31.637 20h-85.306c-8.284 0-15 6.716-15 15v422c0 8.284 6.716 15 15 15h360c8.284 0 15-6.716 15-15v-422c0-8.284-6.716-15-15-15zm-243.058 10h33.058c4.619 0 8.98-2.128 11.823-5.769 2.842-3.641 3.849-8.389 2.729-12.869l-5.341-21.362h41.577l-5.341 21.362c-1.12 4.48-.113 9.229 2.729 12.869 2.844 3.641 7.205 5.769 11.824 5.769h33.058c2.454 0 4.528 1.757 4.932 4.178l4.303 25.822h-144.586l4.304-25.822c.403-2.421 2.477-4.178 4.931-4.178zm228.058 412h-330v-392h63.96l-3.756 22.534c-.725 4.349.5 8.797 3.351 12.161s7.036 5.305 11.445 5.305h180c4.409 0 8.595-1.94 11.445-5.305s4.076-7.813 3.351-12.161l-3.756-22.534h63.96z",
    id: "id_107",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecks);
export default __webpack_public_path__ + "static/media/checks.d302df7cabda4aa26fb86e8fd63b3cc8.svg";
export { ForwardRef as ReactComponent };